import React from 'react';

class Loading extends React.Component {
	render() {
		return(
			<div className="content--container">
				<div className="loading">
					<div className="dots">
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
			</div>
		)
	}
}

export default Loading;


/** WEBPACK FOOTER **
 ** ./src/components/Loading.js
 **/